<div class="dialog" *ngIf="!closeModal && myReferalCustomer?.length > 0">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <h2>{{ 'modals.tree_planted.hi' | translate }} {{ firstName }}</h2>
    <h3>{{ 'modals.tree_planted.h3' | translate }}</h3>
    <img src="/assets/images/wallet.svg" alt="wallet icon" />
    <p>{{ 'modals.tree_planted.p1-1' | translate }} {{ myReferalCustomer }}. {{ 'modals.tree_planted.p1-2' | translate }}</p>
    <p class="bold">
      {{ 'modals.tree_planted.p2-1' | translate: { referee: myReferalCustomer } }}
    </p>
    <ul>
      <li *ngIf="referralIncentiveMonths > 0">
        {{ 'modals.tree_planted.incentive.months' | translate: { referralIncentiveMonths: referralIncentiveMonths } }}
      </li>
      <li *ngIf="referralIncentiveMoney > 0">
        {{
          'modals.tree_planted.incentive.moneyOverall'
            | translate
              : {
                  referralIncentiveMoney: referralIncentiveMoney | translateNumber: customer.language:currentAccount.currency
                }
        }}
      </li>
    </ul>
    <button (click)="close()" class="ui-button full-width">{{ 'modals.tree_planted.cta' | translate }}</button>
  </div>
</div>
